import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "statusFilter", "categoryFilter", "list", "row"]

  filter() {
    const searchTerm = this.hasSearchTarget ? this.searchTarget.value.toLowerCase().trim() : ""
    const statusFilter = this.hasStatusFilterTarget ? this.statusFilterTarget.value : ""
    const categoryFilter = this.hasCategoryFilterTarget ? this.categoryFilterTarget.value : ""

    this.rowTargets.forEach((row) => {
      const matchesSearch = this.matchesSearch(row, searchTerm)
      const matchesStatus = this.matchesStatus(row, statusFilter)
      const matchesCategory = this.matchesCategory(row, categoryFilter)

      row.classList.toggle("hidden", !(matchesSearch && matchesStatus && matchesCategory))
    })
  }

  matchesSearch(row, searchTerm) {
    if (!searchTerm) return true

    const type = (row.dataset.type || "").toLowerCase()
    const filename = (row.dataset.filename || "").toLowerCase()
    const category = (row.dataset.category || "").toLowerCase()

    return (
      type.includes(searchTerm) || filename.includes(searchTerm) || category.includes(searchTerm)
    )
  }

  matchesStatus(row, statusFilter) {
    if (!statusFilter) return true
    return row.dataset.status === statusFilter
  }

  matchesCategory(row, categoryFilter) {
    if (!categoryFilter) return true
    return row.dataset.category === categoryFilter
  }
}
